export class Goal{
    id:number;
    name:string;
    statusId:number;
    
    goalStatusName:string;
}